'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1032 2.42537C16.6711 1.92284 15.9135 1.86572 15.411 2.29779L4.87109 11.3599C4.85933 11.37 4.84732 11.3803 4.83511 11.3908C4.66322 11.5383 4.45035 11.7211 4.29019 11.9036C4.09636 12.1245 3.83845 12.4989 3.83845 13.028C3.83844 13.5572 4.09635 13.9316 4.29018 14.1525C4.45035 14.335 4.66323 14.5178 4.83512 14.6653C4.84732 14.6758 4.85932 14.6861 4.87107 14.6962L15.3205 23.6807C15.823 24.1128 16.5807 24.0557 17.0128 23.5532C17.4448 23.0506 17.3877 22.293 16.8852 21.8609L6.61215 13.0281L16.9756 4.11763C17.4782 3.68556 17.5353 2.92791 17.1032 2.42537Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
